import { OnboardingStepType, OrganizationDetailFragment } from '@alice-financial/alice-sdk'
import { HealthcheckStatusResult } from '../types'
import { getOnboardingStepAssignee, getHealthcheckStatus, getStep } from '../utils/onboardingWorkflowUtils'
import { useSelectedShiftSystem } from './ShiftSurvey'

const STEP_TYPE = OnboardingStepType.ConnectShifts

export const getShiftsStep = (onboardingWorkflow: OrganizationDetailFragment['onboardingWorkflow']) =>
  getStep(onboardingWorkflow, STEP_TYPE)

export const useShiftsStatus = (
  org: OrganizationDetailFragment,
  onboardingWorkflow?: OrganizationDetailFragment['onboardingWorkflow']
): HealthcheckStatusResult | undefined => {
  const assignee = getOnboardingStepAssignee(onboardingWorkflow, STEP_TYPE)
  const step = getShiftsStep(onboardingWorkflow)
  const instructionsCompleteStatus = getHealthcheckStatus(step)
  const selectedSystem = useSelectedShiftSystem(org)
  const nonOnboardingSelectedSystem = !step && selectedSystem
  if (selectedSystem === 'None') return undefined
  const status =
    instructionsCompleteStatus === 'complete' || nonOnboardingSelectedSystem
      ? 'complete'
      : selectedSystem
        ? 'pending'
        : 'incomplete'

  const baseProperties = {
    status,
    assignee,
    healthcheckType: STEP_TYPE,
    healthcheckTitle: 'Shift scheduling',
  } as const

  if (status === 'complete') {
    return {
      ...baseProperties,
      primary: 'Shift scheduling connected',
      secondary: 'We will sync shift information to support benefit processing',
    }
  }

  return {
    ...baseProperties,
    primary: 'Shift scheduling',
    secondary: selectedSystem ? `Connect ${selectedSystem} to Alice` : 'Select a shift scheduling system',
  }
}
